module.exports = __webpack_public_path__ + "static/media/mildly_disagree.f04c6aad.png";